import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { useMemo } from 'react';
import clsx from 'clsx';
import MuiButtonBase from '@material-ui/core/ButtonBase';
import { omit, styled, useThemeProps, } from '../../../foundation';
import { RcIcon } from '../../Icon';
import { RcSnackbarContent } from '../SnackbarContent';
import { snackbarContentActionStyle } from './styles';
import { RcSnackbarActionClasses } from './utils';
var _RcSnackbarAction = function (inProps) {
    var props = useThemeProps({ props: inProps, name: 'RcSnackbarAction' });
    var children = props.children, variant = props.variant, size = props.size, icon = props.icon, _a = props.symbol, symbol = _a === void 0 ? icon : _a, classesProp = props.classes, color = props.color, classNameProp = props.className, rest = __rest(props, ["children", "variant", "size", "icon", "symbol", "classes", "color", "className"]);
    var className = useMemo(function () {
        var _a;
        return clsx(classNameProp, (_a = {},
            _a[RcSnackbarActionClasses.text] = variant === 'text',
            _a[RcSnackbarActionClasses.icon] = variant === 'icon',
            _a));
    }, [classNameProp, variant]);
    var classes = useMemo(function () { return omit(classesProp, ['text', 'icon']); }, [classesProp]);
    return (React.createElement(MuiButtonBase, __assign({ className: className, classes: classes }, rest), variant === 'icon' ? (React.createElement(RcIcon, { size: size, symbol: symbol }, children)) : (children)));
};
var RcSnackbarAction = styled(_RcSnackbarAction)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), snackbarContentActionStyle);
RcSnackbarAction.displayName = 'RcSnackbarAction';
RcSnackbarAction.defaultProps = {
    disableRipple: true,
    variant: 'text',
    size: RcSnackbarContent.defaultProps.size,
};
export { RcSnackbarAction };
var templateObject_1;
